export const ACTION = {
  ADMIN_LOGIN_SUCCESS: "ADMIN_LOGIN_SUCCESS",
};
